// CSV made in the browser from rows already read (reports, People, the audit log), with British
// dates in UK time, and handed to the browser as a download. Nothing is sent anywhere: the file is a
// blob made on the page. Owner and admin only: the screens offer Export CSV to no one else.
//
//   downloadCsv('progress-by-intake', [
//     { key: 'full_name', label: 'Name' },
//     { key: 'starts_at', label: 'Started', format: 'date' },       // 30/09/2026
//     { key: 'last_played_at', label: 'Last watched', format: 'datetime' },  // 30/09/2026 19:05
//     { label: 'Watched', value: r => `${r.recordings_watched} of ${r.recordings_total}` },
//   ], rows)
import { uk } from '../../lib/format.js'

const pad = n => String(n).padStart(2, '0')

// 30/09/2026, the way a spreadsheet in the UK reads a date
export function csvDate(t) {
  if (!t) return ''
  if (/^\d{4}-\d{2}-\d{2}$/.test(t)) {
    const [y, m, d] = t.split('-')
    return `${d}/${m}/${y}`
  }
  const u = uk(t)
  return `${pad(u.d)}/${pad(u.m)}/${u.y}`
}
// 30/09/2026 19:05
export function csvDateTime(t) {
  if (!t) return ''
  const u = uk(t)
  return `${pad(u.d)}/${pad(u.m)}/${u.y} ${pad(u.hh)}:${pad(u.mm)}`
}

function cell(v) {
  if (v === null || v === undefined) return ''
  if (typeof v === 'number') return Number.isFinite(v) ? String(v) : ''
  let s = Array.isArray(v) ? v.join('; ') : typeof v === 'object' ? JSON.stringify(v) : String(v)
  // a cell a spreadsheet would run as a formula is kept as text
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`
  return /[",\n\r;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

function valueOf(col, row) {
  const raw = col.value ? col.value(row) : row[col.key]
  if (col.format === 'date') return csvDate(raw)
  if (col.format === 'datetime') return csvDateTime(raw)
  if (col.format === 'yesno') return raw ? 'Yes' : 'No'
  return raw
}

// The CSV text: a header row of the labels, then 1 line per row
export function toCsv(columns, rows) {
  const lines = [columns.map(c => cell(c.label)).join(',')]
  for (const row of rows || []) lines.push(columns.map(c => cell(valueOf(c, row))).join(','))
  return lines.join('\r\n') + '\r\n'
}

// name-2026-09-30.csv
export function csvFileName(name, nowMs = Date.now()) {
  const u = uk(nowMs)
  const safe = String(name || 'export').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'export'
  return `${safe}-${u.y}-${pad(u.m)}-${pad(u.d)}.csv`
}

// Saves the rows as a .csv file. The byte order mark makes Excel read it as UTF-8 (names with accents).
export function downloadCsv(name, columns, rows) {
  const blob = new Blob(['﻿' + toCsv(columns, rows)], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = /\.csv$/i.test(name) ? name : csvFileName(name)
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
  return a.download
}
